<template>
    <div>
        <mode-checkbox class="option" v-model="valueModel" :label="resource('JourneyBuilder_Sankey_HighlightMode_MostSuccessful_Label')" :option="HIGHLIGHT_MODES.MOST_SUCCESSFUL_ROUTE" />
        <mode-checkbox class="option" v-model="valueModel" :label="resource('JourneyBuilder_Sankey_HighlightMode_LeastSuccessful_Label')" :option="HIGHLIGHT_MODES.LEAST_SUCCESSFUL_ROUTE" />

        <mode-checkbox class="option" v-model="valueModel" :label="resource('JourneyBuilder_Sankey_HighlightMode_MostTaken_Label')" :option="HIGHLIGHT_MODES.MOST_TAKEN_ROUTE" />
        <mode-checkbox class="option" v-model="valueModel" :label="resource('JourneyBuilder_Sankey_HighlightMode_LeastTaken_Label')" :option="HIGHLIGHT_MODES.LEAST_TAKEN_ROUTE" />
    </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';

import HIGHLIGHT_MODES from './highlight-modes';

import resourceMixin from "@core/Util/Mixins/resources";

const {mapGetters} = createNamespacedHelpers('journeyBuilder/reporting');

//Checkbox wrapper component to allow selecting a string value via an array of checkboxes
const ModeCheckbox = {
    render(createElement) {
        return createElement('checkbox', {
            props: {
                //value = checked
                value: this.value === this.option,
                label: this.label,
                disabled: !this.supportedHighlightModes.includes(this.option)
            },
            on: {
                //Arrow function should be used here; our callback function is invoked with `globalThis` bound to the `this` value
                input: checked => this.$emit('input', checked ? this.option : undefined)
            }
        })
    },
    props: ['label', 'value', 'option'],
    computed: {
        ...mapGetters(['supportedHighlightModes'])
    }
}

export default {
    name: "HighlightModeSelector",
    components: {
        ModeCheckbox
    },
    mixins: [resourceMixin],
    watch: {
        supportedHighlightModes(value){
            //Prevent selecting an invalid highlight mode
            if(!value.includes(this.valueModel)){
                this.valueModel = undefined;
            }
        }
    },
    computed: {
        ...mapGetters(['supportedHighlightModes']),
        valueModel: {
            set(value){
                this.$emit('input', value);
            },
            get(){
                return this.value;
            }
        }
    },
    data() {
        return {
            HIGHLIGHT_MODES
        }
    },
    props: {
        value: String
    }
}
</script>

<style scoped lang="scss">
    .option {
        display: inline-block;
        
        &:not(:first-child){
            padding-left: 10px;   
        }
    }
</style>